// PlaceTag — a PLACE, or a scoped thing read beside places, as a chip wearing
// its kind's glyph (a zone · a cluster · a site · a depot · a vehicle pool · the
// whole project · a team): one chip system wherever they are read — a person's
// scope summary, a team's "Works in". A place is a thing, so it is a `Tag`
// (COMPONENTS §Reuse rules); a state would be a Badge.

import type { ReactNode } from 'react';
import { Tag } from '../ui/Tag.js';
import type { Icon } from '../ui/icons.js';

export function PlaceTag({ glyph: Glyph, children }: { glyph: Icon; children: ReactNode }) {
  return (
    <Tag>
      <Glyph size={12} aria-hidden />
      {children}
    </Tag>
  );
}
